<template>
    <div class="checkbox-container">
        <input type="checkbox" :id="id" class="custom-checkbox" v-model="checked" @change="emitChange" />
        <label :for="id" class="checkbox-label"> {{ label }}</label>
    </div>
</template>

<script>
export default {
    name: 'CustomCheckbox',
    props: {
        label: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            default: false
        }
        },
        data() {
        return {
            checked: this.value
        };
    },
    methods: {
        emitChange() {
            this.$emit('change', this.checked);
        }
    }
};
</script>

<style scoped>
.checkbox-container {
    display: flex;
    align-items: center;
}

.custom-checkbox {
    width: 21px;
    height: 21px;
    cursor: pointer; /* Add mouse cursor on hover */
    appearance: none; /* Remove default checkbox styling */
    background-color: var(--white);
    border: 1px solid var(--blue);
    border-radius: 3px;
    position: relative;
    margin-right: 5px;
}

.custom-checkbox:checked::after {
    content: "";
    position: absolute;
    top: 3px;
    left: 3px;
    width: 13px;
    height: 13px;
    background-color: var(--blue);
    border-radius: 2px;
}

.checkbox-label {
  cursor: pointer; /* Change cursor to pointer for label */
  margin-top: 8px;
}
</style>